import { render, staticRenderFns } from "./CiFooter.vue?vue&type=template&id=962777da&scoped=true&"
import script from "./CiFooter.vue?vue&type=script&lang=js&"
export * from "./CiFooter.vue?vue&type=script&lang=js&"
import style0 from "./CiFooter.vue?vue&type=style&index=0&id=962777da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "962777da",
  null
  
)

component.options.__file = "CiFooter.vue"
export default component.exports